import { EDataStatus } from "@/frontend/features/Company/model/types/types";
import { TParsingStatus } from "@/libs/models/portfolio-companies";

export function calculateLoadingProgress(
  status?: EDataStatus | TParsingStatus | null,
  searchStartedAt?: Date | string | null
) {
  const PRE_DONE_STATUS_CAP = 95;
  if (!status || !searchStartedAt || status == EDataStatus.error) {
    return 0;
  }

  if (status === EDataStatus.done) {
    return 100;
  }

  const createdAtUnix =
    searchStartedAt instanceof Date ? searchStartedAt.getTime() : new Date(searchStartedAt).getTime();
  const timeNowUnix = new Date().getTime();
  const secondsPassed = (timeNowUnix - createdAtUnix) / 1_000; // converts this to seconds - J
  const allottedTimeInSeconds = 60;
  if (secondsPassed >= allottedTimeInSeconds) {
    return PRE_DONE_STATUS_CAP; // cap at 95 to make it look like it's still loading - J
  } else {
    return (secondsPassed / allottedTimeInSeconds) * PRE_DONE_STATUS_CAP;
  }
}
